export default __webpack_public_path__ + "static/media/boostsales.a57ac4ad.jpg";